interface PaginationProps {
  page: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <nav aria-label="分页导航" className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-10 items-center gap-1 rounded-md border border-background-300/70 px-3 text-sm text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-base"></i>
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? 'page' : undefined}
          className={`h-10 w-10 rounded-md border text-sm transition-colors cursor-pointer ${
            item === page
              ? 'border-primary-500 bg-primary-500 text-background-50'
              : 'border-background-300/70 text-foreground-400 hover:border-primary-500/50 hover:text-primary-400'
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, page + 1))}
        disabled={page === total}
        className="flex h-10 items-center gap-1 rounded-md border border-background-300/70 px-3 text-sm text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base"></i>
      </button>
    </nav>
  );
}